import { CENTER } from "../../../base/helpers/style";
import { CS } from "../../../base/utils/styler";

export const baseStyle:CS = {
    ...CENTER,
    flexDirection: 'row',
    gap: '10px',
    marginTop: '10px',
    height: '44px'
}